import { render, staticRenderFns } from "./FormTagsStyling.vue?vue&type=template&id=7a7902fa"
import script from "./FormTagsStyling.vue?vue&type=script&lang=js"
export * from "./FormTagsStyling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports